import React from 'react';

import { connect } from 'react-redux';
import QR from 'qrcode.react';
// import QRCode from 'qrcode.react';
import Cookies from 'js-cookie';

import colors from '../util/colors';
import { fireAnalytics } from './utils';

// Actions
import { deleteDevice } from '../store/actions/deviceActions';
import { clearFeaturedPlaylist, clearUserPlaylists, clearActivePlaylist } from '../store/actions/playlistActions';
import { clearUser } from '../store/actions/userActions';
import { clearSubscription } from '../store/actions/subscriptionActions';
import { DELETE_DEVICE_SUCCESS } from '../store/constants/deviceConstants';

import { LEFT, RIGHT, BACK, ENTER, EXIT } from '../util/remoteButtons';

export class Account extends React.Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.selectedBtn = 'None';
    this.selectedBtn1 === 'No';

    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    fireAnalytics("Page", "Account Page Loaded");
    setTimeout(() => {
      const { backButton } = this.refs;
      backButton.focus();
      this.selectedBtn = 'Back';      
    }, 300);
  }

  handleKeyDown(e) {
    e.stopPropagation();
    e.preventDefault();
    switch (e.which) {
      case RIGHT:
        if (this.state.open) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background = '#910048';
          this.refs.yes.focus();
          this.selectedBtn = 'Yes';
        }
        if (this.selectedBtn === 'Back') {
          this.refs.logout.focus();
          this.selectedBtn = 'Logout';
        }
        break;
      case LEFT:
        if (this.state.open) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          this.refs.no.focus();
          this.selectedBtn = 'No';
        }
        if (this.selectedBtn === 'Logout') {
          this.refs.backButton.focus();
          this.selectedBtn = 'Back';
        }
        break;
      case ENTER:
        if (this.state.open) {
          if (this.selectedBtn === 'No') {
            this.setState({ open: false });
            const { backButton } = this.refs;
            backButton.focus();
            this.selectedBtn = 'Back';
            return;
          }
          if (this.selectedBtn === 'Yes') {
            this.props.clearUser();
            this.props.clearSubscription();
            Cookies.remove('auth__token');
            tizen.application.getCurrentApplication().exit();
          }
        } else if (this.selectedBtn === 'Back') {
          this.props.history.goBack();
        } else if (this.selectedBtn === 'Logout') {
          fireAnalytics('User', 'Logged Out', this.props.user.data.user?.email);
          this.logout();
        }
        break;
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        if(this.state.open) {
          this.setState({ open: false });
          const { backButton } = this.refs;
          backButton.focus();
          this.selectedBtn = 'Back';
        } else this.props.history.goBack();
        break;

      case EXIT:
        if(this.state.open) {
          this.setState({ open: false });
          const { backButton } = this.refs;
          backButton.focus();
          this.selectedBtn = 'Back';
        } else this.setState({ open: !this.state.open });
      break;
    }
  }

  logout = async () => {
    try {
      const response = await this.props.deleteDevice(this.props.device.data.id);
      this.props.clearFeaturedPlaylist();
      this.props.clearUserPlaylists();
      this.props.clearActivePlaylist();
      this.props.clearUser();
      this.props.clearSubscription();
      Cookies.remove('auth__token');
      if (response.errors === 'Error') {
        setTimeout(() => {
          this.props.history.push('/error');
        }, 10);
        return;
      }
      if (response.type === DELETE_DEVICE_SUCCESS) {
        this.props.history.push('/');
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    return (
      <div className="UpgradeWrapper">
        {this.state.open ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999', padding: '0%' }}>
            <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
              <img className="logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
              <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
              <button
                ref="no"
                id="No"
                onClick={() => {
                  this.setState({ open: false });
                }}
                style={{ background: '#910048' }}
                className="exitPopup"
              >No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{ marginLeft: '2%' }}
                className="exitPopup"
              >Yes
              </button>
            </div>
          </div>
        ) : null}
        <div className="qrCodeWrapper">
          <div className="content-wrapper">
            <div className="text-wrapper">
              PAIR WITH SMARTPHONE
            </div>
            <div className="scan-text-wrapper">
              Scan the below QR code using the smartphone app to pair your display
            </div>
          </div>
          <div className="qr-wrapper">
            <QR className="QRCode" value={this.props.app.tizenDeviceId} size={300} renderAs="svg" />
            <img className="img-wrapper" src="/assets/img/blackdovelogo.png" alt="" />
          </div>
        </div>
        <div className="downloadButtonWrapper" onKeyDown={this.handleKeyDown}>
          <img className="downloadImg-wrapper" src="/assets/img/TV.png" alt="" />
          <img className="iphone-wrapper" src="/assets/img/iPhone.png" alt="" />
          <div className="info-Content-Wrapper">
            <div className="art-wrapper">
              ACCOUNT
            </div>
            <div className="download-art-wrapper" style={{fontSize:'24px'}}>
              <strong>Account:</strong> {this.props.user.data.user?.email}<br/>
              <strong>Subscription:</strong> {this.props.subscription.data.plan?.name}<br/>
              <div style={{marginTop:'16px', fontSize:'18px'}}>Go to https://account.blackdove.com to change your account details and edit your subscription.</div>
            </div>
          </div>
          <div className="button-Wrapper" style={{top:'80%', padding:'3%'}}>
          <button id="back" ref="backButton" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-backbtn" onClick={() => this.props.history.goBack()}>Close</button>
          <button id="logout" ref="logout" className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-logoutbtn" onClick={() => this.logout()}>Logout</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  deleteDevice: (deviceId) => dispatch(deleteDevice(deviceId)),
  clearFeaturedPlaylist: () => dispatch(clearFeaturedPlaylist()),
  clearUserPlaylists: () => dispatch(clearUserPlaylists()),
  clearActivePlaylist: () => dispatch(clearActivePlaylist()),
  clearUser: () => dispatch(clearUser()),
  clearSubscription: () => dispatch(clearSubscription()),
});

export default connect((state) => {
  const { app, activePlaylist, device, user, subscription } = state;
  return {
    app,
    device,
    user,
    subscription,
    activePlaylist,
  };
}, mapDispatchToProps)(Account);
